/* 3259d4ec43600ea4dd86844b4be4224eb5159893
 * This file is automatically generated by graphql-let. */

import * as Types from '../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NolUserLinkageInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NolUserLinkageInfoQuery = { __typename?: 'Query', memberInfoByCache: { __typename?: 'MemberInfo', linkage: { __typename?: 'LinkageType', NOL: { __typename?: 'NolMemberInfoType', isLinked: boolean } } } };


export const NolUserLinkageInfoDocument = gql`
    query NolUserLinkageInfo {
  memberInfoByCache {
    linkage {
      NOL {
        isLinked
      }
    }
  }
}
    `;

/**
 * __useNolUserLinkageInfoQuery__
 *
 * To run a query within a React component, call `useNolUserLinkageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useNolUserLinkageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNolUserLinkageInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useNolUserLinkageInfoQuery(baseOptions?: Apollo.QueryHookOptions<NolUserLinkageInfoQuery, NolUserLinkageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NolUserLinkageInfoQuery, NolUserLinkageInfoQueryVariables>(NolUserLinkageInfoDocument, options);
      }
export function useNolUserLinkageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NolUserLinkageInfoQuery, NolUserLinkageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NolUserLinkageInfoQuery, NolUserLinkageInfoQueryVariables>(NolUserLinkageInfoDocument, options);
        }
export type NolUserLinkageInfoQueryHookResult = ReturnType<typeof useNolUserLinkageInfoQuery>;
export type NolUserLinkageInfoLazyQueryHookResult = ReturnType<typeof useNolUserLinkageInfoLazyQuery>;
export type NolUserLinkageInfoQueryResult = Apollo.QueryResult<NolUserLinkageInfoQuery, NolUserLinkageInfoQueryVariables>;